import React, { useState } from 'react';
import { Form, message, Popconfirm } from 'antd';
import { deployByFunction } from 'apis/operation/platformImageApis';
import SubmitButton from 'components/button/SubmitButton';
import WarningTextFrame from 'components/etc/WarningTextFrame';
import SmallModal from 'components/form/SmallModal';
import VerticalForm from 'components/form/DefaultForm';
import DefaultInput from 'components/input/DefaultInput';
import { useTranslation } from 'react-i18next';

/**
 *
 * @returns {플랫폼 이미지 라이브 배포 모달}
 */
const PlatformImgLiveDeployModal = ({ visible, setVisible }) => {
  const { t } = useTranslation();
  const [visiblePop, setVisiblePop] = useState(false);
  const [inputData, setInputData] = useState();

  const handleInputReason = (e) => {
    setInputData(e.target.value);
  };
  const handleShow = () => {
    setVisiblePop(true);
  };
  const handleDeploy = async () => {
    const res = await deployByFunction(inputData);
    if (!res) {
      return false;
    }

    setVisiblePop(false);
    setInputData('');
    message.success(t('platformimg.createImageTypeModal.successMessage'), 1);
  };
  const handleClosePop = () => {
    setVisiblePop(false);
  };
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <SmallModal
      title={t('platformimg.liveDeployModal.title')}
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm>
        <p
          style={{
            textAlign: 'center',
            fontSize: '1.2rem',
            marginBottom: '1.2rem',
          }}
        >
          {t('platformimg.liveDeployModal.textConent')}
        </p>
        <Form.Item label={t('platformimg.liveDeployModal.inputTitle')}>
          <DefaultInput onChange={handleInputReason} value={inputData} />
        </Form.Item>
        <WarningTextFrame>
          {t('platformimg.liveDeployModal.warning1')} <br />
          {t('platformimg.liveDeployModal.warning2')}
        </WarningTextFrame>
        <Popconfirm
          title={t('platformimg.liveDeployModal.popConfirm')}
          visible={visiblePop}
          onConfirm={handleDeploy}
          onCancel={handleClosePop}
        >
          <SubmitButton onClick={handleShow}>
            {t('platformimg.liveDeployModal.distribute')}
          </SubmitButton>
        </Popconfirm>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformImgLiveDeployModal;
